import styled from "styled-components";

export const Main = styled.main`
    margin: 0 2.5%;

    @media screen and (min-width: 1000px) {
        margin: 0 5%;
    }
`